import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "../store/index.js";


Vue.use(VueRouter);

const routes = [
    
    {
        path: "/",
        name: "licencevalidation",
        component: () => import("../components/Licence/LicenceValidation.vue"),
        meta: { guest: true },
        props: true

    },

    {
        path: "*",
        name: "licencevalidation",
        component: () => import("../components/Licence/LicenceValidation.vue"),
        meta: { guest: true },
    },
    {
        path: "/licence-registration",
        name: "licenceregistration",
        component: () => import("../components/Licence/LicenceRegistration.vue"),
        meta: { guest: true },
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("../components/Dashboard.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../views/About.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/startnewpole",
        name: "startNewPole",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/startNewPole.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/damageDetail",
        name: "DamageDetail",
        component: () => import("../components/Damages/DamageDetail.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/hollowPole",
        name: "HollowPoleDamageDetail",
        component: () => import("../components/Damages/HollowPoleDamageDetail.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/damageRecord",
        name: "DamageRecord",
        component: () => import("../components/Damages/DamageRecord.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/evaluation",
        name: "Evaluation",
        component: () => import("../components/Evaluation/Evaluation.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/poleInfo",
        name: "PoleInformation",
        component: () => import("../components/PoleInformation.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/settings",
        name: "Settings",
        component: () => import("../components/Settings.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/support",
        name: "Support",
        component: () => import("../components/Support.vue"),
        meta: { guest: true },
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});


router.beforeEach((to, from, next) => {
    if (to.query && to.query.extension && to.query.extension === "2")
    {
        // Your logic here
        //debugger;
        // switch parameter list to lower case
        const queryParams = to.query;
        const normalizedParams = {};
        for (const key in queryParams) {
            if (key != "sascdtl")
                normalizedParams[key.toLowerCase()] = queryParams[key].toLowerCase();
            else
                normalizedParams[key] = queryParams[key];
        }
        //debugger; 

        var featureId = normalizedParams.id ? normalizedParams.id.replace(/^{|}$/g, "") : normalizedParams.id;

        var sourceUrl = normalizedParams.featuresourceurl;
        var itemId = normalizedParams.itemid;

        //var poleId = normalizedParams.id == null ? "" : to.query.id;
        var circ = normalizedParams.circ;
        var sr_circ = normalizedParams.sr_circ;
        var sasc_detail = normalizedParams.sascdtl;
        var readOnly = normalizedParams.readonly == "true";
        var structureName = normalizedParams.structurename

        var fieldMapsDiag = normalizedParams.diag;

        localStorage.setItem("fromFieldMaps",true);
        localStorage.setItem("fieldMapsSourceURL", sourceUrl);
        localStorage.setItem("featureId", featureId);
        localStorage.setItem("itemId", itemId);
        localStorage.setItem("circ", circ);
        localStorage.setItem("sr_circ", sr_circ);
        localStorage.setItem("sasc_detail", sasc_detail);
        localStorage.setItem("readOnly", readOnly);
        localStorage.setItem("fieldMapsDiag", fieldMapsDiag);
        localStorage.setItem("structureName", structureName);
    }
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        

        next("/");
    }
    else {
        next();
    }
});

export default router;
